import styled from "styled-components"
import { Button, ButtonGroup } from "@blueprintjs/core";
import { FormCadastro, FormLogin, FormRecuperar, InputPassword } from "components";
import { MDBInput as Input } from "mdbreact";
import { useState } from "react";
import { InputPoliticaPrivacidade } from "components/InputPoliticaPrivacidade";

const Container = styled.div`
	margin-left: 10px;
`

export const EnterAccount = ({onLogin, ...props}) => {
	const [mode, setMode] = useState('login')
	const active = mode !== 'register'

	return <Container>
		<ButtonGroup large>
			<Button onClick={() => setMode('login')} active={active}>Já possuo uma conta</Button>
			<Button onClick={() => setMode('register')} active={!active}>Criar conta agora</Button>
		</ButtonGroup>

		{mode === 'login' && <FormLogin style={{ margin: "20px 0" }} onSuccess={onLogin}>
			{({ loading, handleSubmit }) => <>
				<Input
					outline
					name="email"
					label="E-mail"
					icon="at"
				/>
				<InputPassword
					outline
					type="password"
					name="senha"
					label="Senha"
					icon="lock"
				/>
				<span>
					Esqueceu a <a href="#!" onClick={() => setMode('recover')}>senha?</a>
				</span>
				<span>
					Não tem uma conta? <a href="#!" onClick={() => setMode('register')}>Cadastre-se</a>
				</span>
				<Button
					style={{ alignSelf: "flex-start" }}
					type="submit"
					intent="success"
					{...{ loading }}
				>ENTRAR</Button>
			</>}
		</FormLogin>}

		{mode === 'recover' && <FormRecuperar
			style={{ margin: "20px 0" }}
			onSuccess={() => setMode('login')}
		>
			{({ loading }) => <>
				<Input
					outline
					name="email"
					label="E-mail"
					icon="at"
					required
				/>
				<ButtonGroup style={{ alignSelf: "flex-start" }}>
					<Button
						type="button"
						icon="chevron-left"
						outlined
						onClick={() => setMode('login')}
					>VOLTAR AO LOGIN</Button>
					<Button
						type="submit"
						intent="primary"
						icon="envelope"
						{...{ loading }}
					>ENVIAR</Button>
				</ButtonGroup>
			</>}
		</FormRecuperar>}

		{mode === 'register' && <FormCadastro style={{ margin: "20px 0" }} onSuccess={onLogin}>
			{({ loading }) => <>
				<Input
					outline
					name="nome"
					label="Nome"
					icon="user"
				/>
				<Input
					outline
					name="email"
					label="E-mail"
					icon="at"
				/>
				<InputPassword
					outline
					type="password"
					name="senha"
					label="Senha"
					icon="lock"
					autoComplete="new-password"
					showRequirements
				/>
				<InputPoliticaPrivacidade orgaoData={{
					sistema: true,
					linkPoliticaPrivacidade: process.env.REACT_APP_BRANDING_POLITICA_PRIVACIDADE
				}} />
				<Button
					style={{ alignSelf: "flex-start" }}
					type="submit"
					intent="success"
					{...{ loading }}
				>CADASTRAR</Button>
			</>}
		</FormCadastro>}
	</Container>
}
